"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const PrismicError = require("./PrismicError.cjs");
const getRepositoryName = (repositoryEndpoint) => {
  try {
    return new URL(repositoryEndpoint).hostname.split(".")[0];
  } catch {
    throw new PrismicError.PrismicError(`An invalid Prismic Rest API V2 endpoint was provided: ${repositoryEndpoint}`, void 0, void 0);
  }
};
exports.getRepositoryName = getRepositoryName;
//# sourceMappingURL=getRepositoryName.cjs.map
